<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="userName" label="用户名" name="userName">
      <a-input v-model:value="formState.userName" />
    </a-form-item>
    <a-form-item ref="account" label="账号" name="account">
      <a-input v-model:value="formState.account" />
    </a-form-item>
    <a-form-item label="密码" name="password">
      <a-input-password
        v-model:value="formState.password"
        :placeholder="isEdit ? '为空表示不更改密码' : ''"
      />
    </a-form-item>
    <a-form-item label="性别" name="gender">
      <a-radio-group v-model:value="formState.gender">
        <a-radio-button :value="0">男</a-radio-button>
        <a-radio-button :value="1">女</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="phone" label="手机号码" name="phone">
      <a-input v-model:value="formState.phone" />
    </a-form-item>
    <a-form-item ref="departId" label="部门" name="departId">
      <a-tree-select
        v-model:value="formState.departId"
        show-search
        placeholder="请选择部门"
        allow-clear
        tree-default-expand-all
        :tree-data="props.treeData"
        tree-node-filter-prop="name"
        :fieldNames="{ label: 'name', value: 'depart_id' }"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
      />
    </a-form-item>
    <a-form-item label="状态" name="status" v-if="props.isEdit">
      <a-radio-group v-model:value="formState.status">
        <a-radio-button :value="1">启用</a-radio-button>
        <a-radio-button :value="0">禁用</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import {
    reactive,
    ref,
    toRaw,
    defineProps,
    defineEmits,
    computed,
    toRefs,
  } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import { createUser, updateUser } from '@/api/system_manage/userManage'
  import { encrypt } from '@/utils/auth'

  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    treeData: Array,
  })
  const store = useStore()
  const config = toRefs(store.getters['user/config'])
  const emit = defineEmits(['submit'])
  const formRef = ref()

  const defaultFormState = props.isEdit
    ? {
        userId: props.editData.user_id,
        userName: props.editData.user_name,
        account: props.editData.account,
        password: props.editData.password,
        gender: props.editData.gender,
        status: props.editData.status,
        phone: props.editData.phone,
        departId: props.editData.depart_id,
      }
    : {
        userName: '',
        account: '',
        password: '',
        gender: '',
        phone: '',
        departId: '',
      }
  const formState = reactive(defaultFormState)
  const rules = {
    userName: [
      {
        required: true,
        message: '请输入用户名',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    account: [
      {
        required: true,
        message: '请输入账号',
        trigger: 'change',
      },
      {
        min: 1,
        max: 50,
        message: '不能超过50个文字',
        trigger: 'blur',
      },
      {
        pattern: /^[0-9a-zA-Z:_]+$/,
        message: '仅限阿拉伯数字、英文字母',
        trigger: 'change',
      },
    ],
    password: props.isEdit
      ? []
      : [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
    gender: [
      {
        required: true,
        message: '请选择性别',
        trigger: 'blur',
      },
    ],
    phone: [
      {
        required: true,
        message: '请输入手机号',
        trigger: 'blur',
      },
    ],
    departId: [
      {
        required: true,
        message: '请选择部门',
        trigger: 'blur',
      },
    ],
  }
  async function handelCreate(data) {
    if (props.isEdit) {
      data = { password: ' ', ...data }
    }
    const ajaxFn = props.isEdit ? updateUser : createUser
    const messageText = props.isEdit ? '编辑' : '创建'
    const encryptData = encrypt(data, config.publicKey.value)

    const res = await ajaxFn({ content: encryptData })
    if (res.success) {
      message.success(messageText + '用户成功！')
      emit('submit')
    } else {
      message.warn(messageText + '用户错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建用户错误：', error)
      })
  }
  function resetForm() {
    formRef.value.resetFields()
  }
  function handleSearch(value) {
    const tree = props.treeData
    const treeData = tree.filter((item) => {
      return item.name.indexOf(value) !== -1
    })
    
  }
</script>
